import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import i18n from '@i18next/i18n';
import { ElementBaseAccessibilityContent } from './base';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ShapeAccessibilityContent } from './shape';
import { PictureAccessibilityContent } from './picture';
import { ChartAccessibilityContent } from './chart';
import { ConnectorAccessibilityContent } from './connector';
import { IAccessibilityManagerContentHandler } from '@src/slide/application/service/accessibility-manager/core/accessibility-manager.interface';

export class GroupAccessibilityContent extends ElementBaseAccessibilityContent {
    public static getCanBeGroupChildAccessibilityContent(
        model: IElementBaseModel,
        isSelected = false,
        content = '',
        a11yManager: IAccessibilityManagerContentHandler,
    ): string {
        const ContentMap = {
            [UIModelType.SHAPE]: ShapeAccessibilityContent,
            [UIModelType.GROUP]: GroupAccessibilityContent,
            [UIModelType.IMAGE]: PictureAccessibilityContent,
            [UIModelType.CHART]: ChartAccessibilityContent,
            [UIModelType.CONNECTOR]: ConnectorAccessibilityContent,
        };
        const ContentModel = (ContentMap[model.type] ?? ElementBaseAccessibilityContent);
        return new ContentModel(model, a11yManager).getAccessibilityContent(isSelected, content);
    }

    private groupModel: IGroupModel;
    public constructor(model: IGroupModel, a11yManager: IAccessibilityManagerContentHandler) {
        super(model, a11yManager);
        this.groupModel = model;
    }

    public getAccessibilityContent(isSelected = false, content = ''): string {
        const { length } = this.groupModel.children;
        let details = i18n.t('组内有{0}个对象。', { 0: length });
        this.groupModel.children.forEach((child) => {
            const childContent = GroupAccessibilityContent
                .getCanBeGroupChildAccessibilityContent(child, isSelected, content, this.a11yManager);
            details += childContent;
        });
        details += i18n.t('组内容已读完');
        return details;
    }
}
